import { createAction } from '@reduxjs/toolkit'
import { call, put, takeEvery } from 'redux-saga/effects'

import { updateFlagComment } from '../../../api/projects-api'
import { FlagComments } from '../../../models/flags'
import { updateFlagComments } from '../../slices/materialFlags'

export const updateFlagCommentAction = createAction<{ flagID: number; flagComment: FlagComments }>(
    'updateFlagCommentAction'
)

export function* handleUpdateFlagComment({ payload }: ReturnType<typeof updateFlagCommentAction>) {
    const { flagID, flagComment } = payload

    yield call(updateFlagComment, {
        comment_id: flagComment.id,
        updated_comment: flagComment.comment,
    })

    yield put(
        updateFlagComments({
            flagID,
            comment: flagComment,
        })
    )
}

export function* watchForUpdateFlagCommentAction() {
    yield takeEvery(updateFlagCommentAction.type, handleUpdateFlagComment)
}
